/* eslint-disable no-fallthrough */
/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
import { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Container,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Snackbar,
    Alert,
    TablePagination,
    Avatar,
    Divider,
    CircularProgress,
    Chip,
    Collapse,
    Tooltip,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import {
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Info as InfoIcon,
    CloudUpload,
    ArrowBack,
    Cancel,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    Search as SearchIcon,
    Email as EmailIcon,
    Phone as PhoneIcon,
    LocationOn as LocationIcon,
    Business as BusinessIcon,
    Verified as VerifiedIcon,
    AttachMoney as MoneyIcon,
    Visibility as ViewIcon,
    Schedule as ScheduleIcon
} from '@mui/icons-material';
import WillingnessService from './willingness/WillingnessService';

const WillingnessDashboard = () => {
    const [activeTab, setActiveTab] = useState('intentCategories');
    const [openForm, setOpenForm] = useState(false);
    const [formType, setFormType] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [loading, setLoading] = useState(true);

    // Enhanced states for service providers
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all');
    const [filterVerified, setFilterVerified] = useState('all');
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);

    // Data states
    const [intentCategories, setIntentCategories] = useState([]);
    const [onboardingContent, setOnboardingContent] = useState([]);
    const [serviceProviders, setServiceProviders] = useState([]);
    const [ceoMessages, setCeoMessages] = useState([]);

    // Form states
    const [categoryForm, setCategoryForm] = useState({ name: '', description: '' });
    const [contentForm, setContentForm] = useState({ title: '', description: '', image: null });
    const [providerForm, setProviderForm] = useState({
        business_name: '',
        category: '',
        project_name: '',
        proposed_hospital: '',
        competency_description: '',
        attachment: null,
        profile_image: null,
        services: [],
        name: '',
        description: '',
        service_provider: ''
    });
    const [ceoForm, setCeoForm] = useState({ ceo_name: '', title: '', message: '', active: false });
    
    // Add state for managing services
    const [services, setServices] = useState([]);
    const [newService, setNewService] = useState({ name: '', description: '' });
const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    providerId: null
});
    // Filter providers based on search and filters
    const filteredProviders = serviceProviders.filter(provider => {
        const matchesSearch = !searchTerm || 
            provider.business_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            provider.primary_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            provider.contact_person_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            provider.city?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            provider.region?.toLowerCase().includes(searchTerm.toLowerCase());

        const matchesStatus = filterStatus === 'all' || 
            (filterStatus === 'active' && provider.is_active) ||
            (filterStatus === 'inactive' && !provider.is_active);

        const matchesVerified = filterVerified === 'all' ||
            (filterVerified === 'verified' && provider.is_verified) ||
            (filterVerified === 'unverified' && !provider.is_verified);

        return matchesSearch && matchesStatus && matchesVerified;
    });

    // Toggle row expansion
    const toggleRowExpansion = (providerId) => {
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            if (newSet.has(providerId)) {
                newSet.delete(providerId);
            } else {
                newSet.add(providerId);
            }
            return newSet;
        });
    };

    // Open provider detail dialog
    const openProviderDetail = (provider) => {
        console.log('Opening provider detail:', provider); // Debug log
        if (!provider || !provider.id) {
            console.error('Cannot open provider detail: Invalid provider data');
            setToast({ open: true, message: 'Error: Invalid provider data', severity: 'error' });
            return;
        }
        setSelectedProvider(provider);
        setDetailDialogOpen(true);
    };
const handleTogglePriority = async (providerId) => {
    setConfirmDialog({
        open: true,
        title: 'Toggle Priority Status',
        message: 'Are you sure you want to toggle priority status for this provider?',
        providerId: providerId,
        onConfirm: async () => {
            setLoading(true);
            try {
                const response = await WillingnessService.toggleServiceProviderPriority(providerId);
                setToast({ 
                    open: true, 
                    message: response.message || 'Priority status updated successfully', 
                    severity: 'success' 
                });
                // Refresh the data
                const providers = await WillingnessService.listServiceProviders();
                setServiceProviders(providers || []);
            } catch (error) {
                console.error('Toggle priority error:', error);
                setToast({ 
                    open: true, 
                    message: 'Failed to update priority status', 
                    severity: 'error' 
                });
            } finally {
                setLoading(false);
                setConfirmDialog({ ...confirmDialog, open: false });
            }
        }
    });
};


    // Enhanced Service Provider Detail Dialog
    const ProviderDetailDialog = () => (
        <Dialog 
            open={detailDialogOpen} 
            onClose={() => setDetailDialogOpen(false)}
            maxWidth="md" 
            fullWidth
        >
            <DialogTitle>
    <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">Provider Details</Typography>
        <Box display="flex" gap={1}>
            {selectedProvider?.priority && (
                <Chip 
                    icon={<span style={{ fontSize: '16px' }}>⭐</span>} 
                    label="Priority" 
                    sx={{ 
                        bgcolor: '#FFD700',
                        color: '#000',
                        fontWeight: 'bold'
                    }} 
                    size="small" 
                />
            )}
            {selectedProvider?.is_verified && (
                <Chip icon={<VerifiedIcon />} label="Verified" color="success" size="small" />
            )}
            <Chip 
                label={selectedProvider?.is_active ? 'Active' : 'Inactive'} 
                color={selectedProvider?.is_active ? 'success' : 'error'} 
                size="small" 
            />
        </Box>
    </Box>
</DialogTitle>
            <DialogContent>
                {selectedProvider && (
                    <Grid container spacing={3}>
                        {/* Header with Avatar and Business Info */}
                        <Grid item xs={12}>
                            <Box display="flex" alignItems="center" gap={2} mb={2}>
                                <Avatar
                                    src={selectedProvider.profile_image}
                                    sx={{ width: 80, height: 80 }}
                                >
                                    {selectedProvider.business_name?.charAt(0)}
                                </Avatar>
                                <Box>
                                    <Typography variant="h5" fontWeight="bold">
                                        {selectedProvider.business_name}
                                    </Typography>
                                    <Typography variant="subtitle1" color="text.secondary">
                                        {selectedProvider.category_name || 'No Category'}
                                    </Typography>
                                    <Box display="flex" gap={1} mt={1}>
                                        <Chip 
                                            label={selectedProvider.availability_status || 'Available'} 
                                            size="small" 
                                            color="primary" 
                                        />
                                        {selectedProvider.years_of_experience && (
                                            <Chip 
                                                label={`${selectedProvider.years_of_experience} years exp.`} 
                                                size="small" 
                                                variant="outlined" 
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        {/* Rating and Priority Status */}
<Grid item xs={12} md={6}>
    <Card variant="outlined">
        <CardContent>
            <Typography variant="h6" gutterBottom>
                Rating & Priority
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="h4" color="gold">
                        {selectedProvider?.average_rating || 0} ★
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        ({selectedProvider?.total_ratings || 0} ratings)
                    </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="body2">
                        <strong>Priority Status:</strong>
                    </Typography>
                    {selectedProvider?.priority ? (
                        <Chip 
                            label="Featured Provider" 
                            size="small"
                            sx={{ 
                                bgcolor: '#FFD700',
                                color: '#000',
                                fontWeight: 'bold'
                            }}
                        />
                    ) : (
                        <Chip 
                            label="Standard" 
                            size="small"
                            variant="outlined"
                        />
                    )}
                </Box>
            </Box>
        </CardContent>
    </Card>
</Grid>
                        {/* Contact Information */}
                        <Grid item xs={12} md={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        <EmailIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                        Contact Information
                                    </Typography>
                                    <Box display="flex" flexDirection="column" gap={1}>
                                        <Typography variant="body2">
                                            <strong>Email:</strong> {selectedProvider.primary_email}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Phone:</strong> {selectedProvider.primary_phone}
                                        </Typography>
                                        {selectedProvider.contact_person_name && (
                                            <Typography variant="body2">
                                                <strong>Contact Person:</strong> {selectedProvider.contact_person_name}
                                            </Typography>
                                        )}
                                        {selectedProvider.whatsapp_number && (
                                            <Typography variant="body2">
                                                <strong>WhatsApp:</strong> {selectedProvider.whatsapp_number}
                                            </Typography>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Location Information */}
                        <Grid item xs={12} md={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        <LocationIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                        Location
                                    </Typography>
                                    <Box display="flex" flexDirection="column" gap={1}>
                                        {selectedProvider.city && (
                                            <Typography variant="body2">
                                                <strong>City:</strong> {selectedProvider.city}
                                            </Typography>
                                        )}
                                        {selectedProvider.region && (
                                            <Typography variant="body2">
                                                <strong>Region:</strong> {selectedProvider.region}
                                            </Typography>
                                        )}
                                        {selectedProvider.physical_address && (
                                            <Typography variant="body2">
                                                <strong>Address:</strong> {selectedProvider.physical_address}
                                            </Typography>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Business Details */}
                        <Grid item xs={12} md={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        <BusinessIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                                        Business Details
                                    </Typography>
                                    <Box display="flex" flexDirection="column" gap={1}>
                                        {selectedProvider.pricing_model && (
                                            <Typography variant="body2">
                                                <strong>Pricing Model:</strong> {selectedProvider.pricing_model}
                                            </Typography>
                                        )}
                                        {selectedProvider.starting_price && (
                                            <Typography variant="body2">
                                                <strong>Starting Price:</strong> {selectedProvider.starting_price} {selectedProvider.currency || 'TZS'}
                                            </Typography>
                                        )}
                                        {selectedProvider.business_hours && (
                                            <Typography variant="body2">
                                                <strong>Business Hours:</strong> {selectedProvider.business_hours}
                                            </Typography>
                                        )}
                                        <Typography variant="body2">
                                            <strong>Created:</strong> {new Date(selectedProvider.created_at).toLocaleDateString()}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Services */}
                        <Grid item xs={12} md={6}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        Services Offered ({selectedProvider.services?.length || 0})
                                    </Typography>
                                    <Box display="flex" flexWrap="wrap" gap={1}>
                                        {selectedProvider.services?.length > 0 ? (
                                            selectedProvider.services.map((service, index) => (
                                                <Chip 
                                                    key={index}
                                                    label={service.name}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                            ))
                                        ) : (
                                            <Typography variant="body2" color="text.secondary">
                                                No services listed
                                            </Typography>
                                        )}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Service Description */}
                        {selectedProvider.service_description && (
                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Service Description
                                        </Typography>
                                        <Typography variant="body2">
                                            {selectedProvider.service_description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDetailDialogOpen(false)}>Close</Button>
                <Button 
                    variant="contained" 
                    onClick={() => {
                        setDetailDialogOpen(false);
                        handleOpenForm('serviceProvider', selectedProvider);
                    }}
                    sx={{ bgcolor: '#001f3f' }}
                >
                    Edit Provider
                </Button>
            </DialogActions>
        </Dialog>
    );

   
const renderEnhancedServiceProvidersTable = () => {
    return (
        <Box>
            {/* Search and Filters */}
            <Box sx={{ mb: 3 }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                        <TextField
                            fullWidth
                            placeholder="Search providers..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={filterStatus}
                                label="Status"
                                onChange={(e) => setFilterStatus(e.target.value)}
                            >
                                <MenuItem value="all">All Status</MenuItem>
                                <MenuItem value="active">Active</MenuItem>
                                <MenuItem value="inactive">Inactive</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} md={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Verified</InputLabel>
                            <Select
                                value={filterVerified}
                                label="Verified"
                                onChange={(e) => setFilterVerified(e.target.value)}
                            >
                                <MenuItem value="all">All</MenuItem>
                                <MenuItem value="verified">Verified</MenuItem>
                                <MenuItem value="unverified">Unverified</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Typography variant="body2" color="text.secondary">
                            {filteredProviders.length} providers found
                            {filteredProviders.filter(p => p.priority).length > 0 && 
                                ` (${filteredProviders.filter(p => p.priority).length} priority)`
                            }
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/* Enhanced Table */}
            <TableContainer component={Paper} elevation={0}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                            <TableCell sx={{ fontWeight: 600 }}>Provider</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Contact</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Location</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Business</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Rating</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Services</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
                            <TableCell sx={{ fontWeight: 600, width: 50 }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredProviders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((provider) => (
                            <>
                                <TableRow 
                                    key={provider.id} 
                                    hover
                                    sx={{
                                        backgroundColor: provider.priority ? 'rgba(255, 215, 0, 0.1)' : 'inherit',
                                        borderLeft: provider.priority ? '4px solid #FFD700' : 'none'
                                    }}
                                >
                                    {/* Provider Info */}
                                    <TableCell>
                                        <Box display="flex" alignItems="center" gap={2}>
                                            <Avatar
                                                src={provider.profile_image}
                                                sx={{ width: 50, height: 50 }}
                                            >
                                                {provider.business_name?.charAt(0)}
                                            </Avatar>
                                            <Box>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    <Typography variant="subtitle2" fontWeight="bold">
                                                        {provider.business_name}
                                                    </Typography>
                                                    {provider.priority && (
                                                        <Chip 
                                                            label="PRIORITY" 
                                                            size="small"
                                                            sx={{ 
                                                                bgcolor: '#FFD700',
                                                                color: '#000',
                                                                fontWeight: 'bold',
                                                                fontSize: '0.65rem',
                                                                height: 18
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                                <Typography variant="body2" color="text.secondary">
                                                    {provider.category_name || 'No Category'}
                                                </Typography>
                                                {provider.years_of_experience && (
                                                    <Typography variant="caption" color="text.secondary">
                                                        {provider.years_of_experience} years experience
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </TableCell>

                                    {/* Contact */}
                                    <TableCell>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                <EmailIcon sx={{ fontSize: 12, mr: 0.5, verticalAlign: 'middle' }} />
                                                {provider.primary_email}
                                            </Typography>
                                            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                <PhoneIcon sx={{ fontSize: 12, mr: 0.5, verticalAlign: 'middle' }} />
                                                {provider.primary_phone}
                                            </Typography>
                                            {provider.contact_person_name && (
                                                <Typography variant="caption" color="text.secondary">
                                                    Contact: {provider.contact_person_name}
                                                </Typography>
                                            )}
                                        </Box>
                                    </TableCell>

                                    {/* Location */}
                                    <TableCell>
                                        <Box>
                                            {provider.city && (
                                                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                    <LocationIcon sx={{ fontSize: 12, mr: 0.5, verticalAlign: 'middle' }} />
                                                    {provider.city}
                                                </Typography>
                                            )}
                                            {provider.region && (
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                                    {provider.region}
                                                </Typography>
                                            )}
                                        </Box>
                                    </TableCell>

                                    {/* Business Info */}
                                    <TableCell>
                                        <Box>
                                            {provider.pricing_model && (
                                                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                                    {provider.pricing_model}
                                                </Typography>
                                            )}
                                            {provider.starting_price && (
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                                    <MoneyIcon sx={{ fontSize: 12, mr: 0.5, verticalAlign: 'middle' }} />
                                                    {provider.starting_price} {provider.currency || 'TZS'}
                                                </Typography>
                                            )}
                                            <Chip 
                                                label={provider.availability_status || 'Available'} 
                                                size="small" 
                                                color="primary" 
                                                variant="outlined"
                                                sx={{ fontSize: '0.7rem', height: 20 }}
                                            />
                                        </Box>
                                    </TableCell>

                                    {/* Status */}
                                    <TableCell>
                                        <Box display="flex" flexDirection="column" gap={0.5}>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                {provider.is_verified ? (
                                                    <Chip 
                                                        icon={<VerifiedIcon sx={{ fontSize: 12 }} />} 
                                                        label="Verified" 
                                                        color="success" 
                                                        size="small" 
                                                        sx={{ fontSize: '0.7rem', height: 20 }}
                                                    />
                                                ) : (
                                                    <Chip 
                                                        label="Unverified" 
                                                        color="warning" 
                                                        size="small" 
                                                        sx={{ fontSize: '0.7rem', height: 20 }}
                                                    />
                                                )}
                                            </Box>
                                            <Chip 
                                                label={provider.is_active ? 'Active' : 'Inactive'} 
                                                color={provider.is_active ? 'success' : 'error'} 
                                                size="small" 
                                                variant="outlined"
                                                sx={{ fontSize: '0.7rem', height: 20 }}
                                            />
                                        </Box>
                                    </TableCell>

                                    {/* Rating - NEW COLUMN */}
                                    <TableCell>
                                        <Box>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <Typography variant="body2" fontWeight="bold" sx={{ fontSize: '0.85rem' }}>
                                                    {provider.average_rating || 0}
                                                </Typography>
                                                <Typography variant="body2" color="gold" sx={{ fontSize: '0.85rem' }}>
                                                    ★
                                                </Typography>
                                            </Box>
                                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                                                {provider.total_ratings || 0} rating{provider.total_ratings !== 1 ? 's' : ''}
                                            </Typography>
                                        </Box>
                                    </TableCell>

                                    {/* Services */}
                                    <TableCell sx={{ maxWidth: 200 }}>
                                        <Box>
                                            <Typography variant="body2" fontWeight="500" sx={{ fontSize: '0.75rem' }}>
                                                {provider.services?.length || 0} services
                                            </Typography>
                                            <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
                                                {provider.services?.slice(0, 2).map((service, index) => (
                                                    <Chip
                                                        key={index}
                                                        label={service.name}
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{ fontSize: '0.65rem', height: 18 }}
                                                    />
                                                ))}
                                                {provider.services?.length > 2 && (
                                                    <Typography variant="caption" color="text.secondary">
                                                        +{provider.services.length - 2} more
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </TableCell>

                                    {/* Actions */}
                                    <TableCell>
                                        <Box display="flex" gap={0.5} flexWrap="wrap">
                                            <Tooltip title="View Details">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => openProviderDetail(provider)}
                                                    color="primary"
                                                >
                                                    <ViewIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={provider.priority ? "Remove Priority" : "Set as Priority"}>
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => handleTogglePriority(provider.id)}
                                                    sx={{
                                                        color: provider.priority ? '#FFD700' : '#gray',
                                                        '&:hover': {
                                                            bgcolor: provider.priority ? 'rgba(255, 215, 0, 0.2)' : 'rgba(0, 0, 0, 0.1)'
                                                        }
                                                    }}
                                                >
                                                    {provider.priority ? (
                                                        <span style={{ fontSize: '20px' }}>⭐</span>
                                                    ) : (
                                                        <span style={{ fontSize: '20px' }}>☆</span>
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Edit Provider">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => handleOpenForm('serviceProvider', provider)}
                                                    color="primary"
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Delete Provider">
                                                <IconButton 
                                                    size="small" 
                                                    onClick={() => handleDelete('Provider', provider.id)}
                                                    color="error"
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </TableCell>

                                    {/* Expand Button */}
                                    <TableCell>
                                        <IconButton 
                                            size="small" 
                                            onClick={() => toggleRowExpansion(provider.id)}
                                        >
                                            {expandedRows.has(provider.id) ? 
                                                <ExpandLessIcon /> : 
                                                <ExpandMoreIcon />
                                            }
                                        </IconButton>
                                    </TableCell>
                                </TableRow>

                                {/* Expanded Row Content */}
                                <TableRow>
                                    <TableCell colSpan={9} sx={{ py: 0 }}>
                                        <Collapse in={expandedRows.has(provider.id)} timeout="auto" unmountOnExit>
                                            <Box sx={{ py: 2, bgcolor: '#fafafa', borderRadius: 1, m: 1 }}>
                                                <Grid container spacing={2}>
                                                    {/* Service Description */}
                                                    {provider.service_description && (
                                                        <Grid item xs={12} md={6}>
                                                            <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                                                                Service Description
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                {provider.service_description}
                                                            </Typography>
                                                        </Grid>
                                                    )}

                                                    {/* Additional Details */}
                                                    <Grid item xs={12} md={6}>
                                                        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                                                            Additional Information
                                                        </Typography>
                                                        <Box display="flex" flexDirection="column" gap={0.5}>
                                                            {provider.priority && (
                                                                <Typography variant="body2">
                                                                    <strong>Priority Status:</strong> ⭐ Featured Provider
                                                                </Typography>
                                                            )}
                                                            <Typography variant="body2">
                                                                <strong>Rating:</strong> {provider.average_rating || 0} ★ ({provider.total_ratings || 0} ratings)
                                                            </Typography>
                                                            {provider.specializations && (
                                                                <Typography variant="body2">
                                                                    <strong>Specializations:</strong> {provider.specializations}
                                                                </Typography>
                                                            )}
                                                            {provider.business_hours && (
                                                                <Typography variant="body2">
                                                                    <strong>Business Hours:</strong> {provider.business_hours}
                                                                </Typography>
                                                            )}
                                                            {provider.website_url && (
                                                                <Typography variant="body2">
                                                                    <strong>Website:</strong> 
                                                                    <a href={provider.website_url} target="_blank" rel="noopener noreferrer">
                                                                        {provider.website_url}
                                                                    </a>
                                                                </Typography>
                                                            )}
                                                            <Typography variant="body2">
                                                                <strong>Created:</strong> {new Date(provider.created_at).toLocaleDateString()}
                                                            </Typography>
                                                            <Typography variant="body2">
                                                                <strong>Last Updated:</strong> {new Date(provider.updated_at).toLocaleDateString()}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </>
                        ))}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={filteredProviders.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(_, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                    }}
                />
            </TableContainer>
        </Box>
    );
};
    // Add these functions for service management
    const addService = () => {
        if (newService.name.trim() === '') return;
        setProviderForm(prev => ({
            ...prev,
            services: [...prev.services, newService]
        }));
        setNewService({ name: '', description: '' });
    };

    const removeService = (index) => {
        setProviderForm(prev => ({
            ...prev,
            services: prev.services.filter((_, i) => i !== index)
        }));
    };

    // Your existing renderForm function
    const renderForm = () => {
        switch (formType) {
            case 'intentCategory':
                return (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {selectedItem ? 'Edit' : 'Create'} Intent Category
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Name"
                                            value={categoryForm.name}
                                            onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            value={categoryForm.description}
                                            onChange={(e) => setCategoryForm({ ...categoryForm, description: e.target.value })}
                                            size="small"
                                            multiline
                                            rows={3}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button type="submit" variant="contained" color="primary" sx={{
                                            backgroundColor: '#001f3f',
                                            '&:hover': {
                                                backgroundColor: '#001a35',
                                            }
                                        }}>
                                            {selectedItem ? 'Update' : 'Create'}
                                        </Button>
                                        <Button onClick={handleCloseForm} sx={{ ml: 2 }}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                );
            case 'onboardingContent':
                return (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {selectedItem ? 'Edit' : 'Create'} Onboarding Content
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Title"
                                            value={contentForm.title}
                                            onChange={(e) => setContentForm({ ...contentForm, title: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            value={contentForm.description}
                                            onChange={(e) => setContentForm({ ...contentForm, description: e.target.value })}
                                            size="small"
                                            multiline
                                            rows={3}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            sx={{
                                                backgroundColor: '#001f3f',
                                                '&:hover': {
                                                    backgroundColor: '#001a35',
                                                }
                                            }}
                                            startIcon={<CloudUpload />}
                                        >
                                            Upload Image
                                            <input
                                                type="file"
                                                hidden
                                                onChange={(e) => setContentForm({ ...contentForm, image: e.target.files[0] })}
                                                accept="image/*"
                                            />
                                        </Button>
                                        {contentForm.image && (
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                {contentForm.image.name}
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button type="submit" variant="contained" color="primary" sx={{
                                            backgroundColor: '#001f3f',
                                            '&:hover': {
                                                backgroundColor: '#001a35',
                                            }
                                        }}>
                                            {selectedItem ? 'Update' : 'Create'}
                                        </Button>
                                        <Button onClick={handleCloseForm} sx={{ ml: 2 }}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                );
            case 'serviceProvider':
                return (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {selectedItem ? 'Edit' : 'Register'} Service Provider
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    {/* Business Information Section */}
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            label="Business Name"
                                            value={providerForm.business_name}
                                            onChange={(e) => setProviderForm({ ...providerForm, business_name: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            label="Project Name"
                                            value={providerForm.project_name}
                                            onChange={(e) => setProviderForm({ ...providerForm, project_name: e.target.value })}
                                            size="small"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            label="Proposed Hospital"
                                            value={providerForm.proposed_hospital}
                                            onChange={(e) => setProviderForm({ ...providerForm, proposed_hospital: e.target.value })}
                                            size="small"
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Competency Description"
                                            value={providerForm.competency_description}
                                            onChange={(e) => setProviderForm({ ...providerForm, competency_description: e.target.value })}
                                            size="small"
                                            multiline
                                            rows={3}
                                        />
                                    </Grid>

                                    {/* File Uploads Section */}
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            startIcon={<CloudUpload />}
                                            fullWidth
                                            sx={{
                                                backgroundColor: '#001f3f',
                                                '&:hover': {
                                                    backgroundColor: '#001a35',
                                                }
                                            }}
                                        >
                                            Upload Attachment
                                            <input
                                                type="file"
                                                hidden
                                                onChange={(e) => setProviderForm({ ...providerForm, attachment: e.target.files[0] })}
                                                accept=".pdf,.doc,.docx"
                                            />
                                        </Button>
                                        {providerForm.attachment && (
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                {providerForm.attachment.name}
                                            </Typography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Button
                                            variant="contained"
                                            component="label"
                                            startIcon={<CloudUpload />}
                                            fullWidth
                                            sx={{
                                                backgroundColor: '#001f3f',
                                                '&:hover': {
                                                    backgroundColor: '#001a35',
                                                }
                                            }}
                                        >
                                            Upload Profile Image
                                            <input
                                                type="file"
                                                hidden
                                                onChange={(e) => setProviderForm({ ...providerForm, profile_image: e.target.files[0] })}
                                                accept="image/*"
                                            />
                                        </Button>
                                        {providerForm.profile_image && (
                                            <Typography variant="body2" sx={{ mt: 1 }}>
                                                {providerForm.profile_image.name}
                                            </Typography>
                                        )}
                                    </Grid>

                                    {/* Services Selection Section */}
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            Select Services
                                        </Typography>
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1,
                                            mb: 2,
                                            p: 2,
                                            border: '1px solid #eee',
                                            borderRadius: 1
                                        }}>
                                            {services.map((service) => (
                                                <Button
                                                    key={service.id}
                                                    variant="outlined"
                                                    onClick={() => {
                                                        // Toggle service selection
                                                        const isSelected = providerForm.services.some(s => s.id === service.id);
                                                        if (isSelected) {
                                                            setProviderForm(prev => ({
                                                                ...prev,
                                                                services: prev.services.filter(s => s.id !== service.id)
                                                            }));
                                                        } else {
                                                            setProviderForm(prev => ({
                                                                ...prev,
                                                                services: [...prev.services, {
                                                                    id: service.id,
                                                                    name: service.name,
                                                                    description: service.description
                                                                }]
                                                            }));
                                                        }
                                                    }}
                                                    sx={{
                                                        backgroundColor: providerForm.services.some(s => s.id === service.id)
                                                            ? 'rgba(0, 128, 0, 0.1)'
                                                            : 'transparent',
                                                        borderColor: providerForm.services.some(s => s.id === service.id)
                                                            ? 'green'
                                                            : 'grey.300',
                                                        color: providerForm.services.some(s => s.id === service.id)
                                                            ? 'green.800'
                                                            : 'text.primary',
                                                        '&:hover': {
                                                            backgroundColor: providerForm.services.some(s => s.id === service.id)
                                                                ? 'rgba(0, 128, 0, 0.2)'
                                                                : 'grey.100',
                                                            borderColor: 'green'
                                                        }
                                                    }}
                                                >
                                                    {service.name}
                                                </Button>
                                            ))}
                                        </Box>
                                    </Grid>

                                    {/* Selected Services List */}
                                    {providerForm.services.length > 0 && (
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Selected Services ({providerForm.services.length})
                                            </Typography>
                                            <Box sx={{
                                                mb: 2,
                                                p: 2,
                                                border: '1px solid #eee',
                                                borderRadius: 1,
                                                backgroundColor: '#f9f9f9'
                                            }}>
                                                {providerForm.services.map((service, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            p: 1.5,
                                                            mb: 1,
                                                            backgroundColor: 'rgba(0, 128, 0, 0.05)',
                                                            borderRadius: 1,
                                                            borderLeft: '4px solid green'
                                                        }}
                                                    >
                                                        <div>
                                                            <Typography variant="subtitle2" fontWeight="bold">
                                                                {service.name}
                                                            </Typography>
                                                            {service.description && (
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {service.description}
                                                                </Typography>
                                                            )}
                                                        </div>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => removeService(index)}
                                                            color="error"
                                                            sx={{
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(255, 0, 0, 0.1)'
                                                                }
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Grid>
                                    )}

                                    {/* Form Actions */}
                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                                backgroundColor: '#001f3f',
                                                '&:hover': {
                                                    backgroundColor: '#001a35',
                                                }
                                            }}
                                        >
                                            {selectedItem ? 'Update' : 'Register'}
                                        </Button>
                                        <Button
                                            onClick={handleCloseForm}
                                            sx={{
                                                ml: 2,
                                                color: '#001f3f',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 31, 63, 0.1)'
                                                }
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                );

            case 'ceoMessage':
                return (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {selectedItem ? 'Edit' : 'Create'} CEO Message
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="CEO Name"
                                            value={ceoForm.ceo_name}
                                            onChange={(e) => setCeoForm({ ...ceoForm, ceo_name: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Title"
                                            value={ceoForm.title}
                                            onChange={(e) => setCeoForm({ ...ceoForm, title: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Message"
                                            value={ceoForm.message}
                                            onChange={(e) => setCeoForm({ ...ceoForm, message: e.target.value })}
                                            size="small"
                                            multiline
                                            rows={4}
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Status</InputLabel>
                                            <Select
                                                value={ceoForm.active}
                                                onChange={(e) => setCeoForm({ ...ceoForm, active: e.target.value })}
                                                label="Status"
                                            >
                                                <MenuItem value={true}>Active</MenuItem>
                                                <MenuItem value={false}>Inactive</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button type="submit" variant="contained" color="primary" sx={{
                                            backgroundColor: '#001f3f',
                                            '&:hover': {
                                                backgroundColor: '#001a35',
                                            }
                                        }}>
                                            {selectedItem ? 'Update' : 'Create'}
                                        </Button>
                                        <Button onClick={handleCloseForm} sx={{ ml: 2, color: '#001a35' }}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                );
            case 'service':
                return (
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                {selectedItem ? 'Edit' : 'Create'} Service
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Service Name"
                                            value={providerForm.name || ''}
                                            onChange={(e) => setProviderForm({ ...providerForm, name: e.target.value })}
                                            size="small"
                                            required
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            value={providerForm.description || ''}
                                            onChange={(e) => setProviderForm({ ...providerForm, description: e.target.value })}
                                            size="small"
                                            multiline
                                            rows={3}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth size="small">
                                            <InputLabel>Service Provider</InputLabel>
                                            <Select
                                                value={providerForm.service_provider || ''}
                                                onChange={(e) => setProviderForm({ ...providerForm, service_provider: e.target.value })}
                                                label="Service Provider"
                                            >
                                                {serviceProviders.map((provider) => (
                                                    <MenuItem key={provider.id} value={provider.id}>
                                                        {provider.business_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                                backgroundColor: '#001f3f',
                                                '&:hover': { backgroundColor: '#001a35' }
                                            }}
                                        >
                                            {selectedItem ? 'Update' : 'Create'}
                                        </Button>
                                        <Button onClick={handleCloseForm} sx={{ ml: 2 }}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                );
            default:
                return null;
        }
    };

    // Your existing useEffect and other functions
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                switch (activeTab) {
                    case 'intentCategories':
                        const categories = await WillingnessService.listIntentCategories();
                        setIntentCategories(categories || []);
                        break;
                    case 'onboardingContent':
                        const content = await WillingnessService.listOnboardingContent();
                        setOnboardingContent(content || []);
                        break;
                    case 'serviceProviders':
                        const [providers, categoriesData] = await Promise.all([
                            WillingnessService.listServiceProviders(),
                            WillingnessService.listIntentCategories()
                        ]);
                        setServiceProviders(providers || []);
                        setIntentCategories(categoriesData || []);
                        break;
                    case 'services':
                        const services = await WillingnessService.getServices();
                        setServices(services || []);
                        break;
                    case 'ceoMessages':
                        const messages = await WillingnessService.listCeoMessages();
                        setCeoMessages(messages || []);
                        break;
                }
            } catch (error) {
                setToast({ open: true, message: 'Failed to fetch data', severity: 'error' });
                console.error('Fetch error:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [activeTab]);

    const handleChangePage = (_, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenForm = (type, item = null) => {
        console.log('Opening form:', type, 'Item:', item); // Debug log
        setFormType(type);
        setSelectedItem(item);

        if (item) {
            switch (type) {
                case 'intentCategory':
                    setCategoryForm({ name: item.name, description: item.description });
                    break;
                case 'onboardingContent':
                    setContentForm({ title: item.title, description: item.description, image: null });
                    break;
                case 'serviceProvider':
                    setProviderForm({
                        business_name: item.business_name || '',
                        category: item.category || '',
                        project_name: item.project_name || '',
                        proposed_hospital: item.proposed_hospital || '',
                        competency_description: item.competency_description || item.service_description || '',
                        attachment: null,
                        profile_image: null,
                        services: item.services || []
                    });
                    break;
                case 'ceoMessage':
                    setCeoForm({
                        ceo_name: item.ceo_name,
                        title: item.title,
                        message: item.message,
                        active: item.active
                    });
                    break;
                case 'service':
                    setProviderForm({
                        name: item?.name || '',
                        description: item?.description || '',
                        service_provider: item?.service_provider || ''
                    });
                    break;
            }
        } else {
            switch (type) {
                case 'intentCategory':
                    setCategoryForm({ name: '', description: '' });
                    break;
                case 'onboardingContent':
                    setContentForm({ title: '', description: '', image: null });
                    break;
                case 'serviceProvider':
                    setProviderForm({
                        business_name: '',
                        category: '',
                        project_name: '',
                        proposed_hospital: '',
                        competency_description: '',
                        attachment: null,
                        profile_image: null,
                        services: []
                    });
                    break;
                case 'ceoMessage':
                    setCeoForm({ ceo_name: '', title: '', message: '', active: false });
                    break;
            }
        }

        setOpenForm(true);
    };

    const handleCloseForm = () => {
        setOpenForm(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let response;
            const isEditMode = Boolean(selectedItem);

            switch (formType) {
                case 'intentCategory': {
                    const payload = {
                        name: categoryForm.name,
                        description: categoryForm.description
                    };
                    response = isEditMode
                        ? await WillingnessService.updateIntentCategory(selectedItem.id, payload)
                        : await WillingnessService.createIntentCategory(payload);
                    break;
                }

                case 'onboardingContent': {
                    const formData = new FormData();
                    formData.append('title', contentForm.title);
                    formData.append('description', contentForm.description);
                    formData.append('active', true);

                    if (contentForm.image) {
                        formData.append('image', contentForm.image);
                    }

                    response = await WillingnessService.createOnboardingContent(formData);
                    break;
                }

                case 'serviceProvider': {
                    const formData = new FormData();

                    // Append basic fields
                    formData.append('business_name', providerForm.business_name);
                    if (providerForm.project_name) formData.append('project_name', providerForm.project_name);
                    if (providerForm.proposed_hospital) formData.append('proposed_hospital', providerForm.proposed_hospital);
                    if (providerForm.competency_description) formData.append('competency_description', providerForm.competency_description);

                    // Append services as IDs
                    if (providerForm.services.length > 0) {
                        providerForm.services.forEach(service => {
                            formData.append('service_ids', service.id);
                        });
                    }

                    // Append files if they exist
                    if (providerForm.attachment) formData.append('attachment', providerForm.attachment);
                    if (providerForm.profile_image) formData.append('profile_image', providerForm.profile_image);

                    response = isEditMode
                        ? await WillingnessService.updateServiceProvider(selectedItem.id, formData)
                        : await WillingnessService.registerServiceProvider(formData);
                    break;
                }

                case 'ceoMessage': {
                    const payload = {
                        ceo_name: ceoForm.ceo_name,
                        title: ceoForm.title,
                        message: ceoForm.message,
                        active: ceoForm.active
                    };
                    response = isEditMode
                        ? await WillingnessService.updateCeoMessage(selectedItem.id, payload)
                        : await WillingnessService.createCeoMessage(payload);
                    break;
                }
                case 'service': {
                    const payload = {
                        name: providerForm.name,
                        description: providerForm.description
                    };
                    response = isEditMode
                        ? await WillingnessService.updateService(selectedItem.id, payload)
                        : await WillingnessService.createService(payload);
                    break;
                }

                default:
                    throw new Error(`Unknown form type: ${formType}`);
            }

            setToast({
                open: true,
                message: `${formType.replace(/([A-Z])/g, ' $1').trim()} ${isEditMode ? 'updated' : 'created'} successfully`,
                severity: 'success'
            });

            setActiveTab(activeTab);
            setOpenForm(false);

        } catch (error) {
            console.error('Submission error:', error);
            setToast({
                open: true,
                message: error.response?.data?.detail ||
                    error.message ||
                    `Failed to ${selectedItem ? 'update' : 'create'} ${formType}`,
                severity: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (type, id) => {
        if (!id) {
            console.error('Cannot delete: ID is undefined');
            setToast({ open: true, message: 'Error: Invalid ID', severity: 'error' });
            return;
        }

        if (!window.confirm(`Are you sure you want to delete this ${type.toLowerCase()}?`)) {
            return;
        }

        setLoading(true);
        try {
            switch (type) {
                case 'Category':
                    await WillingnessService.deleteIntentCategory(id);
                    break;
                case 'Content':
                    await WillingnessService.deleteOnboardingContent(id);
                    break;
                case 'Provider':
                    await WillingnessService.deleteServiceProvider(id);
                    break;
                case 'Message':
                    await WillingnessService.deleteCeoMessage(id);
                    break;
                case 'Service':
                    await WillingnessService.deleteService(id);
                    break;
            }
            setToast({ open: true, message: `${type} deleted successfully`, severity: 'success' });
            setActiveTab(activeTab);
        } catch (error) {
            console.error('Delete error:', error);
            setToast({ open: true, message: `Failed to delete ${type.toLowerCase()}`, severity: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const renderTable = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        const data = {
            'intentCategories': intentCategories,
            'onboardingContent': onboardingContent,
            'serviceProviders': serviceProviders,
            'ceoMessages': ceoMessages,
            'services': services,
        }[activeTab] || [];

        switch (activeTab) {
            case 'serviceProviders':
                return renderEnhancedServiceProvidersTable();
            case 'intentCategories':
                return (
                    <TableContainer component={Paper} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Name</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Description</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Created</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((category) => (
                                    <TableRow key={category.id}>
                                        <TableCell sx={{ fontSize: 10 }}>{category.name}</TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>{category.description}</TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>
                                            {new Date(category.created_at).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => handleOpenForm('intentCategory', category)} size="small">
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton onClick={() => handleDelete('Category', category.id)} size="small">
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                );
            case 'onboardingContent':
                return (
                    <TableContainer component={Paper} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Title</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Description</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Image</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Status</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((content) => (
                                    <TableRow key={content.id}>
                                        <TableCell sx={{ fontSize: 10 }}>{content.title}</TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>{content.description}</TableCell>
                                        <TableCell>
                                            <Avatar
                                                src={content.image}
                                                variant="square"
                                                sx={{ width: 40, height: 40 }}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>
                                            {content.active ? 'Active' : 'Inactive'}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => handleOpenForm('onboardingContent', content)} size="small">
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton onClick={() => handleDelete('Content', content.id)} size="small">
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                );
            case 'ceoMessages':
                return (
                    <TableContainer component={Paper} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>CEO Name</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Title</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Status</TableCell>
                                    <TableCell sx={{ fontSize: 10, fontWeight: 600 }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((message) => (
                                    <TableRow key={message.id}>
                                        <TableCell sx={{ fontSize: 10 }}>{message.ceo_name}</TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>{message.title}</TableCell>
                                        <TableCell sx={{ fontSize: 10 }}>
                                            {message.active ? 'Active' : 'Inactive'}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => handleOpenForm('ceoMessage', message)} size="small">
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton onClick={() => handleDelete('Message', message.id)} size="small">
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                );
            case 'services':
                return (
                    <TableContainer component={Paper} elevation={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 600 }}>Service Name</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Created At</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((service) => (
                                    <TableRow key={service.id} hover>
                                        <TableCell>{service.name}</TableCell>
                                        <TableCell>
                                            {service.description || 'No description'}
                                        </TableCell>
                                        <TableCell>
                                            {new Date(service.created_at).toLocaleDateString()}
                                        </TableCell>
                                        <TableCell>
                                            <IconButton
                                                onClick={() => handleOpenForm('service', service)}
                                                color="primary"
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => handleDelete('Service', service.id)}
                                                color="error"
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                );
            default:
                return null;
        }
    };

    const ConfirmationDialog = () => (
    <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
    >
        <DialogTitle id="confirm-dialog-title">
            <Box display="flex" alignItems="center" gap={1}>
                <InfoIcon color="primary" />
                <Typography variant="h6">{confirmDialog.title}</Typography>
            </Box>
        </DialogTitle>
        <DialogContent>
            <Typography id="confirm-dialog-description">
                {confirmDialog.message}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button 
                onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
                color="inherit"
            >
                Cancel
            </Button>
            <Button 
                onClick={confirmDialog.onConfirm}
                variant="contained"
                sx={{
                    bgcolor: '#001f3f',
                    '&:hover': {
                        bgcolor: '#001a35',
                    }
                }}
                autoFocus
            >
                Confirm
            </Button>
        </DialogActions>
    </Dialog>
);


    return (
        <div className="max-w-8xl mx-auto pl-10 mt-4 mb-4">
            <h5 className="text-xl font-bold mb-4">My Desire Module</h5>

            <div className="flex justify-between mb-2">
                <div>
                    <button
                        className={`mr-1 px-4 py-2 rounded ${activeTab === 'intentCategories' ? 'bg-[#001f3f] text-white' : 'border border-gray-300 rounded'}`}
                        onClick={() => setActiveTab('intentCategories')}
                    >
                        Intent Categories
                    </button>
                    <button
                        className={`mr-1 px-4 py-2 rounded ${activeTab === 'onboardingContent' ? 'bg-[#001f3f] text-white' : 'border border-gray-300 rounded'}`}
                        onClick={() => setActiveTab('onboardingContent')}
                    >
                        Onboarding Content
                    </button>

                    <button
                        className={`mr-1 px-4 py-2 rounded ${activeTab === 'ceoMessages' ? 'bg-[#001f3f] text-white' : 'border border-gray-300 rounded'}`}
                        onClick={() => setActiveTab('ceoMessages')}
                    >
                        CEO Messages
                    </button>

                    <button
                        className={`mr-1 px-4 py-2 rounded ${activeTab === 'services' ? 'bg-[#001f3f] text-white' : 'border border-gray-300 rounded'}`}
                        onClick={() => setActiveTab('services')}
                    >
                        Services
                    </button>
                    <button
                        className={`mr-1 px-4 py-2 rounded ${activeTab === 'serviceProviders' ? 'bg-[#001f3f] text-white' : 'border border-gray-300 rounded'}`}
                        onClick={() => setActiveTab('serviceProviders')}
                    >
                        Service Providers ({filteredProviders.length})
                    </button>
                </div>

                <div className="ml-1">
                    <button
                        className="px-4 py-2 rounded text-white bg-[#001f3f] hover:bg-[#001a35]"
                        onClick={() => handleOpenForm(
                            activeTab === 'intentCategories' ? 'intentCategory' :
                                activeTab === 'onboardingContent' ? 'onboardingContent' :
                                    activeTab === 'serviceProviders' ? 'serviceProvider' :
                                        activeTab === 'services' ? 'service' :
                                            'ceoMessage'
                        )}
                    >
                        Add New
                    </button>
                </div>
            </div>

            <div className="border-t border-gray-300 mb-3"></div>

            {openForm ? (
                <div className="mb-3">
                    <button onClick={handleCloseForm} className="mb-1 p-1 rounded hover:bg-gray-200">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                    {renderForm()}
                </div>
            ) : (
                renderTable()
            )}

            {/* Provider Detail Dialog */}
            <ProviderDetailDialog />
             {/* Confirmation Dialog - ADD THIS */}
        <ConfirmationDialog />
            {toast.open && (
                <div className="fixed bottom-4 left-4 right-4 flex justify-center">
                    <div className={`px-4 py-3 rounded shadow-lg max-w-md w-full ${toast.severity === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                        <div className="flex justify-between items-center">
                            <span>{toast.message}</span>
                            <button onClick={() => setToast({ ...toast, open: false })} className="ml-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WillingnessDashboard;